import { useEffect, useState } from 'react';
import { colorPalette, sizeValues } from '@sharefiledev/antd-config';
import { Check, UserFeedback, Users } from '@sharefiledev/icons';
import { Col, ConfigProvider, Flex, Row, Steps, Tag, theme, Typography } from 'antd';
import { useAppStore } from '../../../Common/store';
import { SignatureRequestQuickFlowDrawerSteps } from '../../../constants';
import { t } from '../../../util';
import { getStepsConfig } from './stepConfig';

const { Text } = Typography;

const ICON_SIZE = sizeValues.SM;

const iconStyle = {
	width: sizeValues.MS,
	height: sizeValues.MS,
	justifyContent: 'center',
	alignItems: 'center',
	gap: 10,
	borderRadius: sizeValues.MD,
};

export const SignatureRequestDrawerHeader = () => {
	const { signatureRequestMetadata } = useAppStore(state => ({
		signatureRequestMetadata: state.signatureRequestMetadata,
	}));
	const [steps, setSteps] = useState([]);
	const { token } = theme.useToken();
	const [isWideScreen, setIsWideScreen] = useState(false);

	useEffect(() => {
		const checkScreenWidth = () => {
			setIsWideScreen(window.innerWidth >= 1260);
		};

		checkScreenWidth();
		window.addEventListener('resize', checkScreenWidth);

		return () => window.removeEventListener('resize', checkScreenWidth);
	}, []);

	useEffect(() => {
		if (signatureRequestMetadata) {
			const iconMapping = {
				Users: (
					<Flex style={{ ...iconStyle, background: colorPalette.lavender3 }}>
						<Users size={ICON_SIZE} />
					</Flex>
				),
				UserFeedback: (
					<Flex
						style={{
							...iconStyle,
							background:
								signatureRequestMetadata.currentStep ===
								SignatureRequestQuickFlowDrawerSteps.ReviewAndSend
									? colorPalette.lavender3
									: colorPalette.neutral3,
						}}
					>
						<UserFeedback size={ICON_SIZE} />
					</Flex>
				),
				CheckCircleFilled: (
					<Flex style={{ ...iconStyle, background: colorPalette.green8 }}>
						<Check size={ICON_SIZE} color={colorPalette.neutral1} />
					</Flex>
				),
			};

			setSteps(
				getStepsConfig(signatureRequestMetadata).map(step => ({
					...step,
					icon: iconMapping[step.icon as keyof typeof iconMapping],
				}))
			);
		}
	}, [signatureRequestMetadata]);

	return (
		<Row>
			{isWideScreen && (
				<Col span={8}>
					<Flex align="center" gap="small" style={{ margin: token.marginXS }}>
						<Text
							style={{
								margin: '0px',
								fontWeight: 550,
								fontSize: '24px',
								lineHeight: '125%',
								lineBreak: 'strict',
							}}
						>
							{t('sendSignatureRequestQuickFlow.header.sendSignature')}
						</Text>
						<Tag>{t('sendSignatureRequestQuickFlow.header.template')}</Tag>
					</Flex>
				</Col>
			)}

			<Col span={!isWideScreen ? 22 : 12}>
				<ConfigProvider
					theme={{
						components: {
							Steps: {
								colorPrimary: colorPalette.green8,
								controlItemBgActive: colorPalette.green8,
								fontSize: 14,
							},
						},
					}}
				>
					<Steps
						items={steps}
						size="small"
						style={{
							height: '100%',
							alignItems: 'center',
							fontStyle: 'normal',
							fontWeight: 400,
						}}
					/>
				</ConfigProvider>
			</Col>
		</Row>
	);
};
